import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: none;
  gap: 16px;
  width: 100%;
  flex-grow: 1;
  min-width: 0;
  overflow-y: auto;
  padding-right: 8px;

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding-right: 0;
    flex-grow: 0;
  }
`;
export const EventSection = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid;
  background-color: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme }) => theme.colors.black4};
  gap: 20px;
  padding: 20px 24px;
  height: auto;
  width: 100%;
  min-width: 0;
  & > * > p {
    margin: 0;
  }
`;
export const EventTitle = styled.span`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  font-style: normal;
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const SecondaryTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SpeakersWrapper = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;

  & > * {
    display: flex;
    min-width: 230px;
    max-width: 270px;
    padding: 4px;
    align-items: center;
    gap: 12px;
    flex: 1 0 0;

    & > :nth-child(2) {
      display: flex;
      flex-direction: column;
      gap: 4px;
      & > :first-child {
        overflow: hidden;
        color: ${({ theme }) => theme.colors.black9};

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  flex: none;
`;

export const SpanDate = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SpanTime = styled.span`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const CalendarButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 16px;
`;

export const DocumentDisplayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SecondaryTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
`;

export const EmojiWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 4px;
`;
export const RecordWrapper = styled.div`
  border-radius: 8px;
  width: 100%;
  height: 100%;
`;

export const RecordSubmitingMessage = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background: ${({ theme }) => theme.colors.purple1};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const VisualizationsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 12px;
`;

export const VisualizationsText = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const ViewedText = styled.div`
  color: ${({ theme }) => theme.colors.green7};
  display: flex;
  align-items: center;
  gap: 4px;
`;
